import clsx from "clsx";

export const AgenticStaffingFlowStatusIndicator = ({
  active,
  className,
}: {
  active: boolean;
  className?: string;
}) => {
  if (active) {
    return (
      <div className={clsx("relative inline-flex h-2 w-2", className)}>
        <div className="absolute h-full w-full rounded-full bg-green-300 opacity-75" />
        <div
          className={clsx(
            "relative h-2 w-2 rounded-full bg-green-600",
            className,
          )}
        />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        "inline-flex h-2 w-2 rounded-full bg-slate-300",
        className,
      )}
    />
  );
};
